var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54065 4.19385L3.33391 9.48705C3.14637 9.67458 3.04102 9.92894 3.04102 10.1942C3.04102 10.4594 3.14637 10.7137 3.33391 10.9013C3.52145 11.0888 3.7758 11.1942 4.04102 11.1942C4.30623 11.1942 4.56059 11.0888 4.74812 10.9013L10.9549 4.60806C11.1406 4.42234 11.2879 4.20187 11.3884 3.95921C11.4889 3.71656 11.5407 3.45649 11.5407 3.19385C11.5407 2.9312 11.4889 2.67113 11.3884 2.42848C11.2879 2.18583 11.1406 1.96535 10.9549 1.77963C10.7691 1.59392 10.5487 1.4466 10.306 1.34609C10.0634 1.24558 9.80329 1.19385 9.54065 1.19385C9.27801 1.19385 9.01793 1.24558 8.77528 1.34609C8.53263 1.4466 8.31215 1.59392 8.12644 1.77963L1.9197 8.07283C1.35709 8.63544 1.04102 9.3985 1.04102 10.1942C1.04102 10.9898 1.35709 11.7529 1.9197 12.3155C2.4823 12.8781 3.24537 13.1942 4.04102 13.1942C4.83667 13.1942 5.59973 12.8781 6.16234 12.3155L11.2907 7.19385",
    stroke: "#677791",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/Attach.9ed751e9af1fe8faae3bb0a587debea7.svg";
export { ForwardRef as ReactComponent };